export default {
  "content": "<style>.st1{fill:#fff}</style><title>Oval 1 Copy 2 + Oval 10 Copy 2 + Rectangle 721 Copy</title><circle id=\"Oval-1-Copy-2\" cx=\"-289\" cy=\"396\" r=\"8\" fill=\"#3d454d\"/><path class=\"st1\" d=\"M-289 401c-.6 0-1-.4-1-1v-5c0-.6.4-1 1-1s1 .4 1 1v5c0 .6-.4 1-1 1z\"/><circle class=\"st1\" cx=\"-289\" cy=\"392\" r=\"1\"/>",
  "attrs": {
    "version": "1.1",
    "id": "Layer_1",
    "xmlns": "http://www.w3.org/2000/svg",
    "x": "0",
    "y": "0",
    "viewBox": "-297 388 16 16",
    "xml:space": "preserve"
  }
};